import {
  SET_TEMPLATE_DATA,
  USER_FETCHING_COMPLETE,
  USER_FETCHING_INIT,
} from "./types";

const initialState = {
  templates: [],
  add_question_modal: {
    enabled: false,
    templates: [],
  },
  options: [],
  is_loading: false,
  delete_question_modal: {
    enabled: false,
    question: {},
  },
  edit_question_modal: {
    enabled: false,
    question: {},
  },
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_TEMPLATE_DATA:
      return { ...state, ...action.payload };
    case USER_FETCHING_INIT: {
      return {
        ...state,
        userlist_fetching: true,
        userlist_refetch: false,
        userlist_refetch_force: false,
      };
    }
    case USER_FETCHING_COMPLETE: {
      return { ...state, userlist_fetching: false, ...action.payload };
    }
    default:
      return state;
  }
};
